import SelectedShow from './SelectedShow.js'
function Popup(props){

  if (!props.show) return null;

  return(
    <>
  <div className="popup-overlay" onClick={props.onClose}></div>
      <div className="popupContainer">
      <div className="popup-content">
        <button className="popup-close" onClick={props.onClose}>×</button>
        <SelectedShow show={props.selectedShow} blackoutData={props.blackoutData} />
      </div>
      </div>
      </>
      )
}
export default Popup;